import * as React from 'react';
import { createStyles, makeStyles, Theme, lighten, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import DeleteIcon from '@material-ui/icons/Delete';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import { Button, IconButton, CssBaseline, FormControlLabel } from '@material-ui/core';
import Files from 'react-files';
import { TatData, ManufacturerData, BranchData } from 'src/reducers/fileUpload';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { green } from '@material-ui/core/colors';
import { LabData } from 'src/reducers/mfileupload';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export interface FilesTableViewProps {
    deleteRowbyId: () => void;
    onUploadAllFiles: () => void;
    onClearAllFiles: () => void;
    onRefreshStatus: () => void;
    onClearAllUploaded: () => void;

    mfilesUpload: Array<File>;
    onFilesChange2: (files: Array<File>) => void;
    onFilesError2: (error: Error, file: Array<File>) => void;
    mprogress: Array<number>;
    msending: boolean;

    onSelectFile: () => void;
    onSelectAllFile: () => void;
    orderDataTat: TatData[];
    orderDataManufacturer: ManufacturerData[];

    mlabData: LabData[];
    mlabChosen: string;
    mbranchData: BranchData[];
    mbranchType: string;

    saveTatType: (event: string, index: number) => void;
    saveMessegeOrder: (event: string, index: number) => void;
    saveManufactType: (event: string, index: number) => void;
    saveDesignSoftware: (event: string, index: number) => void;
    saveOrderModel: (event: string, index: number) => void;
    saveDesignApproval: () => void;
    saveIsBravo: () => void;

    saveLabselected: (lab: string) => void;
    saveBranchType: (branchType: string) => void;

    saveBookingId: (event: string, index: number) => void;
    saveDrPreferences: (event: string, index: number) => void;

}

const BorderLinearProgress = withStyles({
    root: {
        height: 8,
        backgroundColor: lighten('#3f51b5', 0.5),
    },
    bar: {
        borderRadius: 20,
        backgroundColor: '#3f51b5',
    },
})(LinearProgress);

const GreenCheckbox = withStyles({
    root: {
        color: green[400],
        '&$checked': {
            color: green[600],
        },
    },
    checked: {},
})((props: CheckboxProps) => <Checkbox size="small" color="default" {...props} />);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        table: {
            // margin: theme.spacing(1),
            minWidth: 800,
        },
        tableBottom: {
            borderBottom: 'unset',
        },
        forms: {
            width: '100%', // Fix IE 11 issue.
        },
        margin: {
            // margin: theme.spacing(1),
        },
        root1: {
            display: 'flex',
            height: '30vh'
        },
        fileUpload: {
            textAlign: 'center',
            fontSize: '18px',
            color: '#808080',
            height: '20vh',
            border: '2px solid #808080',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderStyle: 'dotted',
            '&:hover': {
                border: '3px solid #3f51b5',
                color: '#3f51b5'
            },
        },
        iconbutton: {
            display: 'flex',
            '& > *': {
                margin: theme.spacing(1),
            },
            justifyContent: 'flex-end'
        },
        filesize: {
            fontSize: '12px',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#3f51b5'
        },
        filesDropzoneActive: {
            border: '3px solid #3f51b5',
            color: '#3f51b5',
        },
        progressError: {
            fontSize: '0.7rem',
            color: '#D2222D'
        },
        progress: {
            fontSize: '0.7rem',
            color: '#FFBF00'
        },
        progressComp: {
            fontSize: '0.7rem',
            color: '#007000'
        },
        tableHeadings: {
            fontSize: '0.9rem'
        },
        '& .MuiTableCell-sizeSmall': {
            padding: '6px 8px 6px 8px'
        },
        iconbuttonTop: {
            display: 'flex',
            justifyContent: 'space-between'
        },
    })
);

const TableStyle = withStyles({
    root: {
        '& .MuiTableCell-sizeSmall': {
            padding: '6px 8px !important'
        }
    },
})(Table);

const FilesTableView: React.StatelessComponent<FilesTableViewProps> = (props) => {

    const classes = useStyles({});

    const inputLabelUser = React.useRef<HTMLLabelElement>(null);
    const [labelWidthUser, setLabelWidthUser] = React.useState(0);
    React.useEffect(() => {
        setLabelWidthUser(inputLabelUser.current!.offsetWidth);
    });

    const inputLabelSbu = React.useRef<HTMLLabelElement>(null);
    const [labelWidthSbu, setLabelWidthSbu] = React.useState(0);
    React.useEffect(() => {
        setLabelWidthSbu(inputLabelSbu.current!.offsetWidth);
    });

    return (
        <div className={classes.root}>
            <Grid container justify="space-between" alignItems="stretch" spacing={2} >
                <Grid item xs={12} sm={12} md={6}>
                    <div className={classes.iconbuttonTop}>
                        <FormControl variant="outlined" size="small" className={classes.forms}>
                            <InputLabel ref={inputLabelUser} htmlFor="outlined-age-simple-1" id="branch-division-1">Select Lab</InputLabel>
                            <Select
                                labelId="branch-division-2"
                                id="branch-division-9"
                                fullWidth
                                onChange={(event) => props.saveLabselected(event.target.value as string)}
                                defaultValue="0"
                                value={props.mlabChosen}
                                disabled={props.msending}
                                input={
                                    <OutlinedInput
                                        labelWidth={labelWidthUser}
                                        name="age"
                                        id="outlined-age-simple-1"
                                    />
                                }
                            >
                                <MenuItem id="us1" disabled value="0">
                                    Select Lab
                                </MenuItem>
                                {props.mlabData.map((lablist, index1) => (
                                    <MenuItem id={lablist.rowno} value={lablist.custcode}>{lablist.custname}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl variant="outlined" size="small" style={{ marginLeft: '16px' }} className={classes.forms}>
                            <InputLabel ref={inputLabelSbu} htmlFor="outlined-age-simple-3" id="branch-division-3">Select Branch / Division</InputLabel>
                            <Select
                                labelId="branch-division-3"
                                id="branch-division-8"
                                fullWidth
                                onChange={(event) => props.saveBranchType(event.target.value as string)}
                                defaultValue="0"
                                value={props.mbranchType}
                                disabled={props.msending}
                                input={
                                    <OutlinedInput
                                        labelWidth={labelWidthSbu}
                                        name="age"
                                        id="outlined-age-simple-3"
                                    />
                                }
                            >
                                <MenuItem id="sb1" disabled value="0">
                                    Select Branch/ Division
                                </MenuItem>
                                {props.mbranchData.map((branchType, index2) => (
                                    <MenuItem id={branchType.rowno} value={branchType.sbu_name}>{branchType.sbu_name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                </Grid>
            </Grid>
            <div className={classes.root1} >
                <Grid container justify="center" alignItems="center" >
                    <Grid item xs={12} sm={12} md={10}>
                        <div className="files">
                            <Files
                                className={classes.fileUpload}
                                onChange={props.onFilesChange2}
                                onError={props.onFilesError2}
                                accepts={['.zip']}
                                multiple
                                maxFiles={100}
                                maxFileSize={5368709120}
                                minFileSize={0}
                                clickable
                                dropActiveClassName={classes.filesDropzoneActive}
                            >
                                You can browse or Drag and drop files to create orders
                            </Files>
                        </div>
                    </Grid>
                </Grid>
            </div >
            <Grid container justify="flex-end" alignItems="center" spacing={2}>
                <Grid item xs={8} sm={8} md={8}>
                    <div className={classes.iconbutton}>
                        {props.mfilesUpload.length > 0 ?
                            <Button type="button" disabled={props.msending} variant="outlined" onClick={props.onUploadAllFiles} color="primary">Send</Button> :
                            <Button type="button" disabled variant="outlined" color="primary">Send</Button>}
                        {props.mfilesUpload.length > 0 ?
                            <Button type="button" disabled={props.msending} variant="outlined" onClick={props.onClearAllFiles} color="secondary">Clear</Button> :
                            <Button type="button" disabled variant="outlined" color="secondary">Clear</Button>}
                        <Button type="button" variant="outlined" onClick={props.onClearAllUploaded} color="secondary">Clear Uploaded</Button>
                    </div>
                </Grid>
            </Grid>
            <CssBaseline />
            <Grid container justify="center" alignItems="center" >
                <Grid item xs={12} sm={12} md={12}>
                    <TableContainer component={Paper}>
                        <TableStyle className={classes.table} size="small" stickyHeader aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">
                                        <Checkbox value={props.mfilesUpload} id="mselectAll" color="primary" onChange={props.onSelectAllFile} />
                                    </TableCell>
                                    <TableCell align="center" id="fileUpl2" className={classes.tableHeadings}>Turn-Around Timee</TableCell>
                                    <TableCell align="center" id="fileUpl3" className={classes.tableHeadings}>Destination</TableCell>
                                    <TableCell align="center" id="fileUpl4" className={classes.tableHeadings}>Design Software</TableCell>
                                    <TableCell align="center" id="fileUpl5" className={classes.tableHeadings}>Model</TableCell>
                                    {/* <TableCell align="center" id="fileUp20" className={classes.tableHeadings}>Booking ID</TableCell> */}
                                    <TableCell align="center" id="fileUpl6" className={classes.tableHeadings}>Design Approval</TableCell>
                                    <TableCell align="center" id="fileUpl7" className={classes.tableHeadings} />
                                    <TableCell align="center" id="fileUpl8" />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Array.isArray(props.mfilesUpload) && props.mfilesUpload.length > 0 && props.mfilesUpload.map((file, index) => (
                                    <React.Fragment key={index}>
                                        <TableRow>
                                            <TableCell rowSpan={2}>
                                                <Checkbox
                                                    size="small"
                                                    color="primary"
                                                    id={(JSON.parse(JSON.stringify(file)).id)}
                                                    value={index}
                                                    checked={JSON.parse(JSON.stringify(file)).selected === true ? true : false}
                                                    onChange={props.onSelectFile}
                                                />
                                            </TableCell>
                                            <TableCell align="left" className={classes.tableBottom}>
                                                <div style={{ fontSize: '0.7rem' }}>
                                                    <FormControl margin="dense" variant="outlined" size="small" className={classes.forms}>
                                                        <Select
                                                            labelId="demo-simple-select-outlined-label"
                                                            id="demo-simple-select-outlined"
                                                            fullWidth
                                                            required
                                                            onChange={(event) => props.saveTatType(event.target.value as string, index as number)}
                                                            value={JSON.parse(JSON.stringify(file)).tat !== undefined ? JSON.parse(JSON.stringify(file)).tat : ''}
                                                        >
                                                            <MenuItem disabled value="">
                                                                <em>Turn Around Time</em>
                                                            </MenuItem>
                                                            {Array.isArray(props.orderDataTat) && props.orderDataTat.length > 0 && props.orderDataTat.map((tatime, index1) => (
                                                                <MenuItem id={tatime.rowno} value={tatime.tattype}>{tatime.tattype}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </TableCell>
                                            <TableCell align="left" className={classes.tableBottom}>
                                                <div style={{ fontSize: '0.7rem' }}>
                                                    <FormControl margin="dense" variant="outlined" size="small" className={classes.forms}>
                                                        <Select
                                                            labelId="demo-simple-select-outlined-label"
                                                            id="demo-simple-select-outlined"
                                                            required
                                                            fullWidth
                                                            onChange={(event) => props.saveManufactType(event.target.value as string, index as number)}
                                                            value={JSON.parse(JSON.stringify(file)).manufactType !== undefined ? JSON.parse(JSON.stringify(file)).manufactType : ''}
                                                        >
                                                            <MenuItem disabled value="">
                                                                <em>Destination</em>
                                                            </MenuItem>
                                                            <MenuItem value="In-House">
                                                                In-House
                                                            </MenuItem>
                                                            {Array.isArray(props.orderDataManufacturer) && props.orderDataManufacturer.length > 0 && props.orderDataManufacturer.map((manufactType) => (
                                                                <MenuItem id={manufactType.rowno} value={manufactType.dest}>{manufactType.dest}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </TableCell>
                                            <TableCell align="left" className={classes.tableBottom}>
                                                <div style={{ fontSize: '0.7rem' }}>
                                                    <FormControl margin="dense" variant="outlined" size="small" className={classes.forms}>
                                                        <Select
                                                            labelId="demo-simple-select-outlined-label"
                                                            id="demo-simple-select-outlined"
                                                            required
                                                            fullWidth
                                                            onChange={(event) => props.saveDesignSoftware(event.target.value as string, index as number)}
                                                            value={JSON.parse(JSON.stringify(file)).designSoftware !== undefined ? JSON.parse(JSON.stringify(file)).designSoftware : ''}
                                                        >
                                                            <MenuItem disabled value="">
                                                                <em>Design Software</em>
                                                            </MenuItem>
                                                            <MenuItem value="Exocad">
                                                                Exocad
                                                            </MenuItem>
                                                            <MenuItem value="3Shape">
                                                                3Shape
                                                            </MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </TableCell>
                                            <TableCell align="left" className={classes.tableBottom}>
                                                <div style={{ fontSize: '0.7rem' }}>
                                                    <FormControl margin="dense" variant="outlined" size="small" className={classes.forms}>
                                                        <Select
                                                            labelId="demo-simple-select-outlined-label-model"
                                                            id="demo-simple-select-outlined-model"
                                                            required
                                                            fullWidth
                                                            onChange={(event) => props.saveOrderModel(event.target.value as string, index as number)}
                                                            value={JSON.parse(JSON.stringify(file)).model !== undefined ? JSON.parse(JSON.stringify(file)).model : ''}
                                                        >
                                                            <MenuItem value="Y">
                                                                Y
                                                            </MenuItem>
                                                            <MenuItem value="N">
                                                                N
                                                            </MenuItem>
                                                            <MenuItem value="S">
                                                                Only Model
                                                            </MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </TableCell>
                                            {/* <TableCell
                                                align="left"
                                                className={classes.tableBottom}
                                            >
                                                <div style={{ fontSize: '0.7rem' }}>
                                                    <FormControl
                                                        margin="dense"
                                                        variant="outlined"
                                                        size="small"
                                                        className={classes.forms}
                                                    >
                                                        <TextField
                                                            variant="outlined"
                                                            label="booking ID"
                                                            // multiline
                                                            fullWidth
                                                            size="small"
                                                            inputProps={{ maxLength: 100 }}
                                                            onChange={(event) => {
                                                                let value = event.target.value;

                                                                // Allow only alphanumeric and spaces, plus newlines (\n for multiline)
                                                                value = value.replace(/[^a-zA-Z0-9 \n]/g, '');
                                                                props.saveBookingId(
                                                                value,
                                                                index
                                                                );
                                                            }}
                                                            value={JSON.parse(JSON.stringify(file)).bookingId}
                                                        />
                                                    </FormControl>
                                                </div>
                                            </TableCell> */}
                                            <TableCell align="center" className={classes.tableBottom}>
                                                <div style={{ fontSize: '0.7rem' }}>
                                                    <FormControlLabel
                                                        control={
                                                            <GreenCheckbox
                                                                checked={JSON.parse(JSON.stringify(file)).approval === true ? true : false}
                                                                value={index}
                                                                onChange={props.saveDesignApproval}
                                                                name="DesignApproval"
                                                            />
                                                        }
                                                        label="Required"
                                                    />
                                                </div>
                                            </TableCell>
                                            {/* <TableCell align="center" className={classes.tableBottom}>
                                                <div style={{ fontSize: '0.7rem' }}>
                                                    <FormControlLabel
                                                        control={
                                                            <GreenCheckbox
                                                                checked={JSON.parse(JSON.stringify(file)).bravopremium === true ? true : false}
                                                                value={index}
                                                                onChange={props.saveIsBravo}
                                                                name="Bravo/Premium"
                                                            />
                                                        }
                                                        label="Bravo / Premium"
                                                    />
                                                </div>
                                            </TableCell> */}
                                            <TableCell align="center" rowSpan={2}>
                                                <IconButton
                                                    size="small"
                                                    onClick={props.deleteRowbyId}
                                                    id={JSON.parse(JSON.stringify(file)).id}
                                                    value={JSON.parse(JSON.stringify(file)).filename}
                                                    color="primary"
                                                    aria-label="delete"
                                                    className={classes.iconbutton}
                                                >
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            {/* <TableCell /> */}
                                            <TableCell component="th" scope="row" colSpan={2}>
                                                <div style={{ wordBreak: 'break-word' }}>
                                                    <span style={{ fontWeight: 900 }}>FILE NAME : </span>
                                                    {`${JSON.parse(JSON.stringify(file)).filename} - (${JSON.parse(JSON.stringify(file)).sizeReadable})`}
                                                    {(props.mprogress[index] > 0 && JSON.parse(JSON.stringify(file)).uploaded === 'uploading') ?
                                                        <div className={classes.progress}>Upload In-Progress</div>
                                                        : (
                                                            JSON.parse(JSON.stringify(file)).uploaded === false
                                                            &&
                                                            <div className={classes.progressError}>Upload error
                                                                {JSON.parse(JSON.stringify(file)).errorReason && ` - ${JSON.parse(JSON.stringify(file)).errorReason}`}
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                                {props.mprogress[index] > 0 ?
                                                    <BorderLinearProgress
                                                        className={classes.margin}
                                                        variant="determinate"
                                                        value={props.mprogress[index]}

                                                    />
                                                    : null}
                                                {props.mprogress[index] === 100
                                                    && JSON.parse(JSON.stringify(file)).uploaded === true
                                                    && <div className={classes.progressComp}>File uploaded</div>
                                                }

                                            </TableCell>
                                            <TableCell align="left">
                                                <div style={{ display: 'grid', gap: '10px', marginTop: '-8px', fontSize: '0.7rem' }}>
                                                    {/* Bravo / Premium Checkbox */}
                                                    <FormControlLabel
                                                        control={
                                                            <GreenCheckbox
                                                                checked={JSON.parse(JSON.stringify(file)).bravopremium === true}
                                                                value={index}
                                                                onChange={props.saveIsBravo}
                                                                name="Bravo/Premium"
                                                            />
                                                        }
                                                        label="Bravo / Premium"
                                                    />

                                                    {/* Message Field */}
                                                    <FormControl
                                                        variant="outlined"
                                                        size="small"
                                                        className={classes.forms}
                                                        style={{ flex: 1 }}
                                                    >
                                                    <TextField
                                                        variant="outlined"
                                                        label="Message"
                                                        // multiline
                                                        fullWidth
                                                        size="small"
                                                        onChange={(event) =>
                                                        props.saveMessegeOrder(event.target.value, index)
                                                        }
                                                        value={JSON.parse(JSON.stringify(file)).msg !== undefined ? JSON.parse(JSON.stringify(file)).msg : ''}
                                                    />
                                                    </FormControl>
                                                </div>
                                            </TableCell>
                                            <TableCell
                                                align="left"
                                                // className={classes.tableBottom}
                                                colSpan={3}
                                            >
                                                <div style={{ fontSize: '0.7rem' }}>
                                                {/* <FormControl
                                                    margin="dense"
                                                    variant="outlined"
                                                    size="small"
                                                    className={classes.forms}
                                                >                                          
                                                    <TextField
                                                        variant="outlined"
                                                        label="Dr Preferences"
                                                        multiline
                                                        rows={3}
                                                        fullWidth
                                                        size="small"
                                                        inputProps={{ maxLength: 3000 }}
                                                        value={JSON.parse(JSON.stringify(file)).drPreferences || ''}
                                                        onChange={(event) => {
                                                            let value = event.target.value;

                                                            // Allow only alphanumeric and spaces, plus newlines (\n for multiline)
                                                            // value = value.replace(/[^a-zA-Z0-9 \n]/g, '');

                                                            // Enforce 3000-character limit
                                                            if (value.length > 3000) {
                                                            value = value.slice(0, 3000);
                                                            }

                                                            props.saveDrPreferences(value, index);
                                                        }}
                                                    />

                                                </FormControl> */}
                                                    <FormControl
                                                        margin="dense"
                                                        variant="outlined"
                                                        size="small"
                                                        className={classes.forms}
                                                    >
                                                        <label className={classes.label}>
                                                            Preferences
                                                        </label>
                                                        <ReactQuill
                                                            theme="snow"
                                                            value={JSON.parse(JSON.stringify(file)).drPreferences || ''}
                                                            onChange={(value) => {
                                                                props.saveDrPreferences(value, index);
                                                            }}
                                                            modules={{
                                                                toolbar: [
                                                                    ['bold', 'italic', 'underline'],
                                                                    [{ color: [] }, { background: [] }],
                                                                    [{ list: 'ordered' }, { list: 'bullet' }],
                                                                    ['link'],
                                                                    ['clean'],
                                                                ],
                                                            }}
                                                        />                                               
                                                    </FormControl>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </TableStyle>
                    </TableContainer>
                </Grid>
            </Grid>
        </div>
    );
};

export default FilesTableView;



// WEBPACK FOOTER //
// ./src/components/layouts/MFilesTableView.tsx